import consumer from "./consumer"

consumer.subscriptions.create("ReportsChannel", {
  connected() {
  },

  disconnected() {
  },

  received(data) {
    switch (data.type) {
      // Report Previews (async notifications)
      case 'cluster_preview_ready':
        if (window.ClusterPreviewClient && window.clusterReportPreviewConfig && data.cluster_report_id === window.clusterReportPreviewConfig.reportId) {
          window.ClusterPreviewClient.onReady && window.ClusterPreviewClient.onReady();
        }
        break;
      case 'cluster_preview_error':
        if (window.ClusterPreviewClient && window.clusterReportPreviewConfig && data.cluster_report_id === window.clusterReportPreviewConfig.reportId) {
          window.ClusterPreviewClient.onError && window.ClusterPreviewClient.onError(data.error || 'Error building preview');
        }
        break;
      case 'routes_preview_ready':
        if (window.RoutesPreviewClient && window.routesPreviewConfig && data.routes_report_id === window.routesPreviewConfig.reportId) {
          window.RoutesPreviewClient.onReady && window.RoutesPreviewClient.onReady();
        }
        break;
      case 'routes_preview_error':
        if (window.RoutesPreviewClient && window.routesPreviewConfig && data.routes_report_id === window.routesPreviewConfig.reportId) {
          window.RoutesPreviewClient.onError && window.RoutesPreviewClient.onError(data.error || 'Error building preview');
        }
        break;
      case 'ranking_preview_ready':
        if (window.RankingPreviewClient && window.rankingPreviewConfig && data.ranking_report_id === window.rankingPreviewConfig.reportId) {
          window.RankingPreviewClient.onReady && window.RankingPreviewClient.onReady();
        }
        break;
      case 'ranking_preview_error':
        if (window.RankingPreviewClient && window.rankingPreviewConfig && data.ranking_report_id === window.rankingPreviewConfig.reportId) {
          window.RankingPreviewClient.onError && window.RankingPreviewClient.onError(data.error || 'Error building preview');
        }
        break;
      // Cluster Reports
      case 'cluster_report_published':
        $(`#cluster_report_${data.id}`).find("div.report_url").html(
          `<a target='_blank' class='action-btn' href='${data.report_url}'>Open</a>`
        );
        toastr.success('Report published successfully');
        break;
      case 'cluster_report_attached':
        Turbolinks.visit(location.toString());
        break;
      case 'cluster_report_error':
        toastr.error(data.error, `Cluster Report: ${data.title}`);
        $(`#cluster_report_${data.id}`).find("div.report_url").html(``);
        break;
      case 'cluster_report_unpublished':
        $(`#cluster_report_${data.id}`).find("div.report_url").html(``);
        toastr.success('Report unpublished successfully');
        break;

      // Routes Reports
      case 'routes_report_published':
        $(`#routes_report_${data.id}`).find("div.report_url").html(
          `<a target='_blank' class='action-btn' href='${data.report_url}'>Open</a>`
        );
        toastr.success('Report published successfully');
        break;
      case 'routes_report_error':
        toastr.error(data.error, `Ranking Report: ${data.title}`);
        $(`#routes_report_${data.id}`).find("div.report_url").html(``);
        $(`#routes_report_${data.id}`).find("div.report_url").remove();
        break;
      case 'routes_report_gif_start':
        $(`#routes_report_${data.id}`).find("td.report_gif").find('a').hide();
        $(`#routes_report_${data.id}`).find("td.report_gif").append(
          `<div class='spinner-border text-primary' role='status'><span class='sr-only'>Loading...</span></div>`
        );
        break;
      case 'routes_report_gif':
        $(`#routes_report_${data.id}`).find("td.report_gif")
          .find('div.spinner-border').remove().end()
          .find('a').show();

        const animationFileName = data.name;
        if (data.s3_key !== null) {
          utils.triggerFileDownload(animationFileName, data.s3_key);
        } else {
          const blob = utils.b64toBlob(data.file, 'image/gif');
          const url = URL.createObjectURL(blob);
          utils.triggerFileDownload(animationFileName, url);
        }
        break;
      case 'routes_report_gif_error':
        toastr.error('Error generating animation', `Routes Report: ${data.title}`)
        break;
      case 'routes_report_unpublished':
        $(`#routes_report_${data.id}`).find("div.report_url").html(``);
        $(`#routes_report_${data.id}`).find("td.report_gif").html(``);
        toastr.success('Report unpublished successfully');
        break;
      
      // Ranking Reports
      case 'ranking_report_published':
        $(`#ranking_report_${data.id}`).find("div.report_url").html(
          `<a target='_blank' class='action-btn' href='${data.report_url}'>Open</a>`
        );
        toastr.success('Report published successfully');
        break;
      case 'ranking_report_error':
        toastr.error(data.error, `Ranking Report: ${data.title}`);
        $(`#ranking_report_${data.id}`).find("div.report_url").html(``);
        break;
      case 'ranking_report_unpublished':
        $(`#ranking_report_${data.id}`).find("div.report_url").html(``);
        toastr.success('Report unpublished successfully');
        break;

      // Trend Reports
      case 'trends_report_published':
        $(`#trends_report_${data.id}`).find("div.report_url").html(
          `<a target='_blank' class='action-btn' href='${data.report_url}'>Open</a>`
        );
        toastr.success('Report published successfully');
        break;
      case 'trends_report_error':
        toastr.error(data.error, 'Trends Report');
        $(`#trends_report_${data.id}`).find("div.report_url").html(``);
        break;
      case 'trends_report_unpublished':
        $(`#trends_report_${data.id}`).find("div.report_url").html(``);
        toastr.success('Report unpublished successfully');
        break;

      // File Reports
      case 'file_report_published':
        $(`#file_report_${data.id}`).find("div.report_url").html(data.html);
        if (data.indexed_icon_html) {
          $(`#file_report_${data.id}`).find("td.indexed-status").html(data.indexed_icon_html);
        }
        toastr.success('Report published successfully');
        break;
      case 'file_report_publish_error':
        toastr.error(data.error, 'File Report');
        $(`#file_report_${data.id}`).find("div.report_url").html(``);
        break;
      case 'file_report_unpublished':
        $(`#file_report_${data.id}`).find("div.report_url").html(``);
        if (data.indexed_icon_html) {
          $(`#file_report_${data.id}`).find("td.indexed-status").html(data.indexed_icon_html);
        }
        toastr.success('Report unpublished successfully');
        break;

      default:
        console.warn(`Unhandled notification type: ${data.type}`);
    }
  }
});